import api from '@/plugins/axios'

export const getAll = async () => {
  const response = await api.get('/horario')
  return response.data
}

export const getActuales = async () => {
  const response = await api.get('/horario/actuales')
  return response.data
}

export const getById = async (id) => {
  const response = await api.get(`/horario/${id}`)
  return response.data
}

export const create = async (data) => {
  const response = await api.post('/horario', data)
  return response.data
}

export const update = async (id, data) => {
  const response = await api.put(`/horario/${id}`, data)
  return response.data
}

export const remove = async (id) => {
  await api.delete(`/horario/${id}`)
}
